export const TOKEN_KEY = 'HV_PROD_LANDING_TOKEN';
export const BACKEND_URL = 'https://highvocab.com/api';
export const STRIPE_PUBLISHABLE_KEY =
  'pk_live_51MuMhVJtM93s8Cf1kaG7mBVeXC9tWiyUgnQ92CJGy89mmElHAJtlRi6lPSMihpHNjas8YiIZr20KjHehw85vddyT00qQnB7yXv';
export const FREE_VERSION = false;
// YouTube id of the "how to use HighVocab" tutorial.
export const TUTORIAL_VIDEO_ID = 'pw8wU4qb_OM';
export const TUTORIAL_VIDEO_DURATION = '1:46';

// export const TOKEN_KEY = 'HV_LOCAL_LANDING_TOKEN';
// export const BACKEND_URL = 'http://localhost:4000/api';
// export const STRIPE_PUBLISHABLE_KEY =
//   'pk_test_51MuMhVJtM93s8Cf1khWqXSCsgHELs5MCfhsxEdty8e52itloMAVIdeEr1WbXnvifW8h6FQ2Rgsl7qAbi2vKqBpwo00YRebWxPE';
